<template>
  <div class="supporting-photos">
    <div class="component-title">Upload Supporting Photos (optional)</div>
    <div class="row">
      <div class="col s12">
        <div class="description">
          Upload photos of your home to illustrate the features listed below.
          Multiple photos can be uploaded for each.
        </div>
      </div>
    </div>
    <div class="row grid">
      <div v-for="(item, key, index) in photosX" :key="index" class="col s12">
        <div class="left flex-text">
          <!-- v-if="item.id && item.link" -->
          <div
            class="preview-item"
            v-if="item.images.length > 0"
            :style="[{ backgroundImage: `url(${item.images[0].link})` }]"
          ></div>
          <div class="title left" v-html="item.text"></div>
        </div>
        <button
        :disabled="userRole === 'subscriber'"
          class="btn btn-rounded amber lighten-1 z-depth-0 grey-text text-darken-3 right"
          @click="$_selectImage('add', item, key)"
          v-if="item.images.length <= 0"
        >
          Add
        </button>
        <button
        :disabled="userRole === 'subscriber'"
          class="btn btn-rounded amber lighten-1 z-depth-0 grey-text text-darken-3 right"
          @click="$_selectImage('update', item, key)"
          v-else
        >
          Edit
        </button>
        <div class="clear"></div>
        <!-- <button class="btn waves-effect waves-black white">ADD</button> -->
      </div>
      <!-- <div
        class="file-field input-field"
        v-for="(item, index) in photos"
        :key="index"
      >
        <div class="btn">
          <span>File</span>
          <input
            type="file"
            @change="$_getFile(item.key, item.id, item.text, $event)"
            accept="image/*"
          />
        </div>
        <div class="file-path-wrapper">
          <input class="file-path validate" type="text" />
        </div>
      </div> -->
      <edit-home-image-modal
        v-if="openModal"
        :data-action="action"
        :data-image="selectedImage"
        :data-home-profile-images="photos"
        :dataKey="selectedKey"
        @refresh="$_getData()"
        @close="$_reset()"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import editHomeImageModal from "./editHomeImageModal.vue";
export default {
  components: { editHomeImageModal },
  name: "SupportingPhotos",
  data() {
    return {
      photos: {
        front_view: {
          text: "Front view of your house",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        roof: {
          text: "Roof (clearly showing the design)",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        roof_covering: {
          text: "Roof covering",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        celling: {
          text: "Ceiling",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        typical_roof_overhang: {
          key: "typical_roof_overhang",
          text: "Typical roof overhang",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        each_type_of_window: {
          text: "Each type of window",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        each_type_exterior_door: {
          text: "Each type of exterior door",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        porches: {
          text: "All porches/verandas",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        gararge_carport: {
          text: "Garage/Carport",
          value: "",
          id: "",
          link: "",
          images: [],
        },
        foundation: {
          text:
            "Foundation/base of house (where the walls connect to the ground or supporting structures - e.g. columns or stilts)",
          value: "",
          id: "",
          link: "",
          images: [],
        },
      },

      openModal: false,
      action: null,
      selectedImage: null,
      selectedKey: null,
    };
  },
  mounted() {
    this.$_getData();
  },
  computed: {
    ...mapState({ user: (state) => state.User.user }),
    userRole: {
      get () {
      return this.user && this.user.roles.length > 0
      ? this.user.roles[0]
      : false 
      }
     },
    photosX() {
      const { adaptation_plan, ...res } = this.photos;
      return res;
    },
  },
  methods: {
    $_getData() {
      if (this.user.home_profile_images) {
        this.photos = JSON.parse(this.user.home_profile_images);
      }
    },
    $_reset() {
      this.openModal = false;
      this.action = null;
      this.selectedImage = null;
      this.selectedKey = null;
    },
    $_selectImage(actionType, image, key) {
      this.action = actionType;
      this.selectedImage = image;
      this.selectedKey = key;
      this.openModal = true;
    },
    // $_getFile(keyx, idx, text, event) {
    //   const dataObj = {
    //     id: idx,
    //     key: keyx,
    //     title: text,
    //     file: event.target.files[0],
    //   };

    //   const index = this.editData.findIndex(({ key }) => key === keyx);

    //   if (index > -1) {
    //     this.editData[index] = dataObj;
    //   } else {
    //     this.editData.push(dataObj);
    //   }
    //   this.$emit("images", this.editData);
    // },
  },
};
</script>
<style lang="scss" scoped>
.supporting-photos {
  padding: 24px 18px;
  background: #efefef;
  margin: 16px 0px 0px;
  @media screen and (min-width: 768px) {
    padding: 24px 20%;
  }
  .component-title {
    padding: 0 10px 10px;
    font-size: 18px;
    font-weight: 600;
  }
  .grid {
    .col {
      margin: 6px 0px;
      border-bottom: 1px solid #e2e2e2;
      padding: 0px 12px 8px;
    }
  }
  .flex-text {
    display: flex;
    .title {
      font-size: 16px;
    }
  }
  .preview-item {
    width: 36px;
    height: 36px;
    background-size: cover !important;
    margin-right: 8px;
    border-radius: 4px;
  }
}
</style>
